<template>
  <v-row>
    <!-- اضافه شدن فیلد ID -->
    <v-col cols="12" md="6">
      <v-text-field
        v-model.number="localValue.id"
        label="آیدی کارت NFC (ID)"
        type="number"
        min="1"
        outlined
        dense
        @input="updateValue"
      ></v-text-field>
    </v-col>

    <v-col cols="12" md="6">
      <v-text-field
        v-model.number="localValue.count"
        label="تعداد کیوآرکد (حداکثر ۲۰۰)"
        type="number"
        min="1"
        max="200"
        outlined
        dense
        @input="updateValue"
      ></v-text-field>
    </v-col>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="localValue.title"
        label="عنوان"
        outlined
        dense
        @input="updateValue"
      ></v-text-field>
    </v-col>

    <v-col cols="12" md="6">
      <v-select
        v-model="localValue.status"
        :items="statusItems"
        label="وضعیت"
        outlined
        dense
        @change="updateValue"
      >
        <template v-slot:selection="{ item }">
          <v-icon left small color="primary">{{ item.icon }}</v-icon>
          {{ item.text }}
        </template>
        <template v-slot:item="{ item }">
          <v-icon left small color="primary">{{ item.icon }}</v-icon>
          {{ item.text }}
        </template>
      </v-select>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "BulkSettingsPanel",
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localValue: { ...this.value },
      statusItems: [
        { text: "آماده شده", value: "complete", icon: "mdi-check-all" },
        {
          text: "اختصاص داده شده",
          value: "assigned",
          icon: "mdi-account-check",
        },
        { text: "موجود", value: "available", icon: "mdi-check-circle" },
        { text: "ناموجود", value: "unavailable", icon: "mdi-close-circle" },
      ],
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.localValue = { ...newVal };
      },
      deep: true,
    },
  },
  methods: {
    updateValue() {
      this.$emit("input", this.localValue);
    },
  },
};
</script>
